import { useState } from "react";
import { Expand, Instagram } from "lucide-react";
import { FadeIn } from "./Reveal";
import Lightbox from "./Lightbox";

const renders = [
  { img: "/render-5.jpg", title: "Render 3D" },
  { img: "/render-1.jpg", title: "Render 3D" },
  { img: "/render-2.jpg", title: "Render 3D" },
  { img: "/render-3.jpg", title: "Render 3D" },
  { img: "/render-4.jpg", title: "Render 3D" },
  { img: "/render-6.jpg", title: "Render 3D" },
];

export default function WhyUs() {
  const [active, setActive] = useState(null);

  return (
    <section id="perche" data-testid="why-us-section" className="relative bg-[#F4F1EA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-28 lg:pt-36">
        <FadeIn>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1C1B1A]">
            <span className="inline-block border-b border-[#E30613] pb-1">Render 3D</span>
            <span className="block mt-4 italic font-display text-2xl sm:text-3xl font-medium tracking-tight text-[#1C1B1A]">Dare forma a ciò che ancora non esiste</span>
          </h2>
        </FadeIn>
      </div>
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <FadeIn delay={0.15}>
          <p data-testid="why-us-text" className="mt-10 text-base sm:text-lg leading-loose text-[#1C1B1A]/80">
            Attraverso la realizzazione di Render 3D fotorealistici, trasformiamo il progetto in una visione concreta
            degli spazi futuri. Ogni dettaglio, dai materiali alle finiture, dai colori all'illuminazione, viene
            studiato per restituire un'anteprima fedele del risultato finale. Un modo per visualizzare, valutare e
            definire ogni scelta prima ancora che il progetto prenda vita.
          </p>
        </FadeIn>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-28 lg:pb-36 mt-14 lg:mt-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {renders.map((r, i) => (
            <FadeIn key={r.img} delay={(i % 3) * 0.08}>
              <figure
                data-testid={`render-item-${i}`}
                onClick={() => setActive(i)}
                className="group relative overflow-hidden cursor-zoom-in"
              >
                <img
                  src={r.img}
                  alt="Render 3D fotorealistico FKL"
                  loading="lazy"
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute bottom-3 right-3 w-7 h-7 rounded-full bg-white shadow-md flex items-center justify-center text-[#1C1B1A] group-hover:bg-[#E30613] group-hover:text-white group-hover:scale-110 transition-[background-color,color,transform] duration-300">
                  <Expand className="w-3.5 h-3.5" strokeWidth={2} />
                </span>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>

      <img src="/fkl-logo.png" alt="" aria-hidden="true" className="absolute bottom-5 right-6 w-16 sm:w-20 pointer-events-none" />
      <a
        href="https://www.instagram.com/fkl.official_"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram FKL"
        data-testid="ig-float-render"
        className="absolute bottom-5 left-6 w-8 h-8 rounded-full bg-[#1C1B1A] flex items-center justify-center text-white hover:bg-[#E30613] hover:scale-110 transition-[background-color,transform] duration-300"
      >
        <Instagram className="w-4 h-4" strokeWidth={1.75} />
      </a>

      <Lightbox
        items={renders}
        active={active}
        onClose={() => setActive(null)}
        onPrev={() => setActive((a) => (a - 1 + renders.length) % renders.length)}
        onNext={() => setActive((a) => (a + 1) % renders.length)}
        testidPrefix="render-lightbox"
      />
    </section>
  );
}
